// @ts-nocheck
import React, { useEffect } from 'react';

/**
 * Generic legal-document modal used for both Terms of Service and Privacy
 * Notice. The trailing punctuation in the headline is rendered separately so
 * the italic emphasis only covers the noun ("Service" / "Notice").
 */
const LegalModal = ({
  open,
  onClose,
  eyebrow,
  titleLead,
  titleEm,
  titleTrail = '.',
  content,
  fullLink,
  onAgree,
}) => {
  useEffect(() => {
    if (!open) return undefined;
    const onKey = (e) => { if (e.key === 'Escape') onClose(); };
    document.addEventListener('keydown', onKey);
    const prevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = prevOverflow;
    };
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="modal-veil fixed inset-0 z-50 flex items-center justify-center p-6 auth-root"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="legal-heading"
    >
      <div
        className="bg-mov-paper max-w-2xl w-full max-h-[80vh] flex flex-col border border-mov-line-strong rounded-md2 overflow-hidden shadow-card"
        onClick={e => e.stopPropagation()}
      >
        <div className="px-7 py-5 border-b border-mov-line flex items-start justify-between gap-4">
          <div>
            <div className="mono text-[11px] uppercase text-mov-green-ink mb-1" style={{ letterSpacing: '0.14em' }}>
              {eyebrow}
            </div>
            <h3 id="legal-heading" className="display text-[26px] leading-tight text-mov-ink m-0">
              {titleLead}
              {' '}
              <em>{titleEm}</em>
              {titleTrail}
            </h3>
          </div>
          <button
            type="button"
            onClick={onClose}
            aria-label="Close"
            className="bg-transparent border-0 p-1 text-mov-ink-mute hover:text-mov-ink cursor-pointer mono text-[14px]"
          >
            ✕
          </button>
        </div>
        <div className="px-7 py-5 overflow-auto text-[14px] text-mov-ink-soft whitespace-pre-wrap leading-relaxed">
          {content}
        </div>
        <div className="px-7 py-4 border-t border-mov-line flex items-center justify-between gap-2.5">
          <div>
            {fullLink && (
              <a
                href={fullLink}
                target="_blank"
                rel="noreferrer"
                className="mono text-[11px] uppercase text-mov-ink-soft hover:text-mov-ink no-underline border-b border-dotted border-mov-line-strong pb-px"
                style={{ letterSpacing: '0.12em' }}
              >
                Read full version
              </a>
            )}
          </div>
          <div className="flex gap-2.5">
            <button
              type="button"
              onClick={onClose}
              className="bg-transparent border border-mov-line-strong rounded-sm2 px-4 py-2 text-[13px] font-medium text-mov-ink hover:border-mov-ink-mute cursor-pointer"
            >
              {onAgree ? 'Cancel' : 'Close'}
            </button>
            {onAgree && (
              <button
                type="button"
                onClick={onAgree}
                className="border-0 rounded-sm2 px-4 py-2 text-[13px] font-medium text-white bg-mov-ink hover:bg-black cursor-pointer"
              >
                I agree
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
